import difference from 'lodash/difference';
import {
    GET_NOTIFICATION_TEMPLATES_REQUEST,
    GET_NOTIFICATION_TEMPLATES_SUCCESS,
    GET_NOTIFICATION_TEMPLATES_FAILURE,
} from '../actions/actionTypes';

const initState = {
    isFetching: false,
    templates: [],
    resourceList: [],
    totalResults: 0,
    totalPages: 0,
    currentPage: 0,
};

const notificationTemplatesReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_NOTIFICATION_TEMPLATES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_NOTIFICATION_TEMPLATES_SUCCESS: {

            const existingTemplates = [...state.templates];
            const newTemplates = difference(action.response.resourceList, existingTemplates);
            const templates = [
                ...existingTemplates,
                ...newTemplates,
            ];

            return Object.assign({}, state, {
                isFetching: false,
                totalResults: action.response.totalResults,
                totalPages: action.response.totalPages,
                currentPage: action.response.page,
                resourceList: action.response.resourceList,
                templates: templates,
            });
        }
        case GET_NOTIFICATION_TEMPLATES_FAILURE:
            return Object.assign({}, initState);
        default:
            return state;
    }
};

export default notificationTemplatesReducer;
